export default {
  BONUS_MODELLER_TITLE: 'Bonus Modeller',
  BONUS_MODELLER_SUBTITLE: 'Please set bonus eligibility information',
  BONUS_MODELLER_CAPTION:
    'Bonus modeller settings used to configure the eligibility, bonus pay and target percentages.',
  BONUS_MODELLER_PAGE_SUBTITLE:
    'Bonus details will be presented in the Employee Statement only for the employees eligible for bonus, based on configurations in this section.',
  BONUS_MODELLER_ELIGIBLE_POPULATION: 'Eligible Population',
  BONUS_MODELLER_BONUS_COMPENSATION: 'Bonus Compensation',
  BONUS_MODELLER_BONUS_MIDPOINT: 'Bonus Midpoint',
  BONUS_MODELLER_INDIVIDUAL_PERFORMANCE: 'Individual Performance',
  BONUS_MODELLER_BUSINESS_PERFORMANCE: 'Business Performance',
  BONUS_MODELLER_COMPENSATION_LABEL: 'Compensation',
  BONUS_MODELLER_COMPENSATION_PLACEHOLDER:
    'Start by inserting a %value% or a function (%min%, %max%, %round%, %round up%, %round down%).',
  BONUS_MODELLER_MIDPOINT_LABEL: 'Midpoint',
  BONUS_MODELLER_MIDPOINT_PLACEHOLDER:
    'Start by inserting a %value% or a function (%min%, %max%, %round%, %round up%, %round down%).',
  BONUS_MODELLER_PROVIDE_DISCLAIMER: 'Provide Disclaimer',
  BONUS_MODELLER_PROVIDE_DISCLAIMER_DESCRIPTION:
    'The disclaimer will be displayed on the printed version of the Employee Statement for each employee.',
  BONUS_MODELLER_DISCLAIMER: 'Disclaimer',
  BONUS_MODELLER_BUTTON_SAVE_AND_CONTINUE: 'Save and Continue',
  BONUS_MODELLER_STATUS: 'Status',
  BONUS_MODELLER_REVERT_TO_DRAFT_BUTTON: 'Revert to draft',
  BONUS_MODELLER_REVERT_TO_DRAFT_POPUP_TITLE: 'Revert %CURRENT_STATUS% bonus modeller to draft?',
  BONUS_MODELLER_REVERT_TO_DRAFT_LOSE_CHANGES: 'You will lose any unsaved changes when reverting to draft.',
  BONUS_MODELLER_REVERT_TO_DRAFT_SUCCESS: 'Bonus modeller successfully moved to draft.',
};
